module.exports = __webpack_public_path__ + "static/media/SIPCBackgroundImage.e0d4b04f.svg";